export default __webpack_public_path__ + "static/media/walrus.821ae379.png";